import { extendTheme } from '@chakra-ui/react';
import { globalStyles } from './styles';
import { breakpoints } from './foundations/breakpoints';
import { textStyles } from './foundations/text';
import { badgeStyles } from './components/badge';
import { buttonStyles } from './components/button';
import { drawerStyles } from './components/drawer';
import { formStyles } from './components/form';
import { linkStyles } from './components/link';
import { menuStyles } from './components/menu';
import { dividerStyles } from './components/divider';
import { CardComponent } from './additions/card/Card';
import { CardBodyComponent } from './additions/card/CardBody';
import { CardHeaderComponent } from './additions/card/CardHeader';
import { MainPanelComponent } from './additions/layout/MainPanel';
import { PanelContentComponent } from './additions/layout/PanelContent';
import { PanelContainerComponent } from './additions/layout/PanelContainer';

export default extendTheme(
  { 
    config: {
      initialColorMode: 'dark',
      useSystemColorMode: false,
    }
  },
  { breakpoints }, 
  globalStyles,
  buttonStyles, 
  badgeStyles,
  linkStyles,
  textStyles, 
  drawerStyles,
  CardComponent,
  CardBodyComponent, 
  CardHeaderComponent,
  MainPanelComponent,
  PanelContentComponent,
  PanelContainerComponent,
  formStyles,
  menuStyles,
  dividerStyles
);
